import { render, staticRenderFns } from "./BackupIndex.vue?vue&type=template&id=6bf7a976&scoped=true"
import script from "./BackupIndex.vue?vue&type=script&lang=js"
export * from "./BackupIndex.vue?vue&type=script&lang=js"
import style0 from "./BackupIndex.vue?vue&type=style&index=0&id=6bf7a976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7a976",
  null
  
)

export default component.exports